import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </M>
  );
};

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs uppercase tracking-[0.3em] text-[#A8613C] font-semibold ${className}`}>{children}</p>
);
